import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import moment from "moment";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Button from "components/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getStores, getRandomUserStores } from "actions/stores";
import COLORS from "shared/constants/colors";
import { imagesBaseURL } from "shared/requests";
import WooCommerceLogo from "assets/svg/WooCommerceLogo";
import UpdateOrderStatusModal from "pages/warehouse/UpdateOrdersModal";
import {
  Container,
  Heading,
  Footer,
  StoreWrapper,
} from "styles/pages/orders/retrieveLatestOrder";

const RetrieveLatestOrder = ({
  retrieveShopifyOrders,
  emailId,
  loggedInUser = false,
}) => {
  const dispatch = useDispatch();
  const csvEl = useRef(null);
  const [value, setValue] = useState(undefined);
  const [modal, setModal] = useState(false);
  const stores = useSelector((state) => state?.stores?.data);
  const [csvData, setCsvData] = useState(null);
  const [randomUserStores, setRandomUserStores] = useState(null);
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const [
    updateOrderStatusModalVisibility,
    setUpdateOrderStatusModalVisibility,
  ] = useState({ open: false });

  const isAdmin = emailid === "developer@bigoventees.com";

  useEffect(() => {
    const fetchStores = async () => {
      if (loggedInUser && !stores?.length) {
        return dispatch(getStores(emailid));
      } else if (!loggedInUser) {
        const data = await dispatch(getRandomUserStores(emailId));
        setRandomUserStores(data);
      }
    };

    fetchStores();
  }, [dispatch, loggedInUser, emailid, emailId]);

  const storesData = loggedInUser ? stores : randomUserStores;

  return (
    <React.Fragment>
      {!isAdmin && (
        <Button
          title="Generate Late Orders Report"
          containerStyle={{
            background: "#000",
            boxShadow: "none",
            height: "34px",
            textTransform: "capitalize",
            color: COLORS.WHITE,
          }}
          onClick={() =>
            setUpdateOrderStatusModalVisibility({ open: true, csv: true })
          }
        />
      )}

      <Button
        onClick={() => setModal(true)}
        title="Retrieve Latest Order"
        containerStyle={{
          background: COLORS.BLACK,
          boxShadow: "none",
          height: "34px",
          textTransform: "capitalize",
          color: COLORS.WHITE,
        }}
      />

      <Dialog
        maxWidth="md"
        open={modal}
        onClose={() => {
          setValue(null);
          setModal(false);
        }}
      >
        <Container>
          <Heading>Retrieve Orders</Heading>
          {!storesData?.length ? (
            <h3>No stores connected.</h3>
          ) : (
            <RadioGroup
              name="retrieve-latest-orders"
              onChange={(e) => setValue(e.target.value)}
            >
              {storesData?.map((store, index) => (
                <StoreWrapper key={`StoreWrapper${index}`}>
                  <FormControlLabel
                    key={`ShopID${index}`}
                    value={store.ShopID}
                    control={<Radio color="primary" />}
                    label={store.ShopName}
                    style={{ textTransform: "capitalize" }}
                  />
                  {store.MarketplaceType === "Shopify" && (
                    <img
                      src={`${imagesBaseURL}/Images/store-logo-shopify_shdure.png`}
                      alt="Shopify"
                      width="100"
                    />
                  )}
                  {store.MarketplaceType === "Etsy" && (
                    <img
                      src={`${imagesBaseURL}/Images/store-logo-etsy_pucy8l.png`}
                      alt="Shopify"
                      width="40"
                    />
                  )}

                  {store.MarketplaceType === "WooCommerce" && (
                    <WooCommerceLogo />
                  )}
                </StoreWrapper>
              ))}
            </RadioGroup>
          )}
          <Footer>
            <Button
              title="Retrieve"
              disabled={!value}
              onClick={() => {
                const selectedStore = _.find(
                  storesData,
                  (s) => s.ShopID === value
                );
                if (selectedStore) {
                  retrieveShopifyOrders(selectedStore);
                  setValue(null);
                  setModal(false);
                }
              }}
            />
          </Footer>
        </Container>
      </Dialog>

      {updateOrderStatusModalVisibility?.open && (
        <UpdateOrderStatusModal
          open={updateOrderStatusModalVisibility?.open}
          csv={updateOrderStatusModalVisibility?.csv}
          email={emailid}
          setOpen={({ open, orders }) => {
            if (orders?.length && updateOrderStatusModalVisibility?.csv) {
              let csvData = [
                [
                  "Order#",
                  "Email",
                  "Submit To Production Date",
                  "Shipping Address",
                  "Ship Date",
                  "Delay Days",
                  "Print Provider",
                  "Tracking Number",
                ],
              ];
              for (let i = 0; i < orders?.length; i++) {
                const order = orders[i];
                const ShirtlyOrderData = order?.ShirtlyOrderData;
                const {
                  ID,
                  MasterUserEmail,
                  PrintProvider,
                  BuyerName,
                  AddressLineOne,
                  AddressLineTwo,
                  City,
                  ZipPostal,
                  StateProvince,
                  CountryString,
                } = ShirtlyOrderData;
                const orderSubmitToProductionDate =
                  order?.OrderSubmitToProductionDate;
                const diff = moment().diff(orderSubmitToProductionDate, "days");
                csvData.push([
                  `BOT-${ID}`,
                  MasterUserEmail,
                  orderSubmitToProductionDate,
                  `${BuyerName}\n${AddressLineOne} ${AddressLineTwo} ${City} ${StateProvince} ${ZipPostal}, ${CountryString}`,
                  "",
                  `${diff} Days`,
                  `${PrintProvider} Plant`,
                  "",
                ]);
              }
              setCsvData(csvData);
              setTimeout(() => {
                csvEl.current.link.click();
              }, 10);
            } else {
              setCsvData(undefined);
            }
            setUpdateOrderStatusModalVisibility({
              open: open,
              csv: false,
            });
          }}
        />
      )}

      {csvData && (
        <CSVLink
          style={{ display: "none" }}
          ref={csvEl}
          data={csvData}
          filename={`BOT_Late_Orders_Report(${moment().format(
            "MMM DD YYYY"
          )}).xls`}
        />
      )}
    </React.Fragment>
  );
};

export default RetrieveLatestOrder;
